/** Límites que la ficha pública recorta o que el editor debe avisar. */

export const SEO_TITLE_SUFFIX = ' | AiPeces';

export const FICHA_LENGTH_LIMITS = {
    seoTitle: 60,
    seoDescription: 155,
    imagenAlt: 125,
    nombre: 70,
    descripcionCorta: 160,
} as const;

export interface FichaFieldInput {
    nombre: string;
    descripcionCorta: string;
    seoTitle: string;
    seoDescription: string;
    imagenAlt: string;
}

export interface FichaFieldNotice {
    field: keyof FichaFieldInput;
    level: 'warning' | 'block';
    message: string;
}

function overLimit(field: FichaFieldNotice['field'], label: string, value: string, limit: number): FichaFieldNotice | null {
    if (value.length <= limit) return null;
    return {
        field,
        level: 'warning',
        message: `${label}: ${value.length}/${limit}.`,
    };
}

/** Avisos de longitud. El SEO title por encima de 60 bloquea el guardado. */
export function assessFichaFields(input: FichaFieldInput): FichaFieldNotice[] {
    const notices: FichaFieldNotice[] = [];
    const title = input.seoTitle;
    if (title.trim() && !title.trim().endsWith(SEO_TITLE_SUFFIX)) {
        notices.push({
            field: 'seoTitle',
            level: 'warning',
            message: `El SEO title no termina en «${SEO_TITLE_SUFFIX}».`,
        });
    }
    if (title.length > FICHA_LENGTH_LIMITS.seoTitle) {
        notices.push({
            field: 'seoTitle',
            level: 'block',
            message: `SEO title: ${title.length}/${FICHA_LENGTH_LIMITS.seoTitle}. La web lo recorta a 60 sin avisar.`,
        });
    }
    const checks: Array<FichaFieldNotice | null> = [
        overLimit('seoDescription', 'SEO description', input.seoDescription, FICHA_LENGTH_LIMITS.seoDescription),
        overLimit('imagenAlt', 'Alt', input.imagenAlt, FICHA_LENGTH_LIMITS.imagenAlt),
        overLimit('nombre', 'Nombre', input.nombre, FICHA_LENGTH_LIMITS.nombre),
        overLimit('descripcionCorta', 'Descripción corta', input.descripcionCorta, FICHA_LENGTH_LIMITS.descripcionCorta),
    ];
    for (const notice of checks) {
        if (notice) notices.push(notice);
    }
    return notices;
}

export function fichaSaveBlocked(notices: FichaFieldNotice[]): boolean {
    return notices.some((notice) => notice.level === 'block');
}

export function noticesForField(
    notices: FichaFieldNotice[],
    field: FichaFieldNotice['field'],
): FichaFieldNotice[] {
    return notices.filter((notice) => notice.field === field);
}
